import {defineStore} from "pinia";
import api from "@/plugins/axios";

export const useServiceStore = defineStore('service', {
    state: () => ({
        items: [],
        item: {}
    }),
    actions: {
        async getList() {
            try {
                const {data} = await api.get(`services`);
                this.items = data;
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        },
        async getListByProject(projectId) {
            try {
                const {data} = await api.get(`services`, {params: {projectId}});
                this.items = data;
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        },
        async getById(serviceId) {
            try {
                const {data} = await api.get(`services/${serviceId}`);
                this.item = data
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        },
        async create(item) {
            try {
                const {data} = await api.post(`services`, item);
                this.item = data
                return data
            } catch (error) {
                console.error('Error creating user:', error);
            }
        },
        async delete(serviceId) {
            try {
                await api.delete(`services/${serviceId}`);
            } catch (error) {
                console.error('Error deleting user:', error);
            }
        },
        async update(id, item) {
            try {
                const {data} = await api.patch(`services/${id}`, item);
                this.item = data
                return data
            } catch (error) {
                console.error('Error updating user:', error);
            }
        },
    }
})
